export default __webpack_public_path__ + "static/media/data-analysis.c823f0d7.png";